const DOCUMENT = 'ADD_NEW_PRICE_LIST_IMPORT_FILE_';

const actions = {
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  SHOW_MODAL: DOCUMENT + 'SHOW_MODAL',
  CLOSE_MODAL: DOCUMENT + 'CLOSE_MODAL',
  IMPORT_CSV_REQUEST: DOCUMENT + 'IMPORT_CSV_REQUEST',
  IMPORT_CSV_SUCCESS: DOCUMENT + 'IMPORT_CSV_SUCCESS',
  IMPORT_CSV_ERROR: DOCUMENT + 'IMPORT_CSV_ERROR',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  showModal: () => ({
    type: actions.SHOW_MODAL,
  }),

  closeModal: () => ({
    type: actions.CLOSE_MODAL,
  }),

  importCsvRequest: data => ({
    type: actions.IMPORT_CSV_REQUEST,
    payload: data,
  }),

  importCsvSuccess: data => ({
    type: actions.IMPORT_CSV_SUCCESS,
    payload: data,
  }),

  importCsvError: data => ({
    type: actions.IMPORT_CSV_ERROR,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
